import { render, staticRenderFns } from "./resultado-becas.vue?vue&type=template&id=aa1398d8&"
import script from "./resultado-becas.component.ts?vue&type=script&lang=ts&"
export * from "./resultado-becas.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports